import { Button } from '@kizen/kds/Button';
import { useTranslation } from 'react-i18next';
import { FC, useRef, useState } from 'react';
import { wysiwygCopyLocalStorage } from 'storage/components';

export const ClipboardButton: FC<{ value: string; className?: string }> = ({
  value,
  className,
}) => {
  const { t } = useTranslation();

  const [copied, setCopied] = useState(false);

  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleCopyToClipboard = () => {
    clearTimeout(timeoutRef.current);
    navigator.clipboard.writeText(value);
    wysiwygCopyLocalStorage.clear()
    setCopied(true);
    timeoutRef.current = setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className={className}>
      <Button
        key={String(copied)}
        leftIcon="custom-clipboard"
        leftIconSettings={{
          size: 'md',
          tooltipDescriptionOverride: copied
            ? t('Copied')
            : t('Copy to Clipboard'),
        }}
        variant="text"
        color="secondary"
        onClick={handleCopyToClipboard}
      />
    </div>
  );
};
